import {
  BoxThemeComponent,
  InputThemeComponent,
  CircleThemeComponent,
  TagsThemeComponent,
} from "../../Components/Uploader/Themes";

export const UploaderThemesEnum = {
  Box: {
    key: "Box",
    component: BoxThemeComponent,
  },
  Input: {
    key: "Input",
    component: InputThemeComponent,
  },
  Circle: {
    key: "Circle",
    component: CircleThemeComponent,
  },
  Tags: {
    key: "Tags",
    component: TagsThemeComponent,
  },
};
